var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { DebtorVoucherTypes } from '@debbie/common/dist/economy/vouchers/setup';
import { c, h } from '@debbie/cortex/dist';
import { useBillingModels } from '@debbie/cortex/dist/billing-models';
import { selectVoucherTypes } from '@debbie/cortex/dist/economy/selectors';
import { Input } from '../..';
import FilterGroup from '../FilterGroup';
import FilterOption from '../FilterOption';
let tid = null;
const EconomyGroup = (props) => {
    var _a;
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    const billingModelsLoadable = useBillingModels();
    const billingModels = h.hasData(billingModelsLoadable) && billingModelsLoadable.data;
    const voucherTypes = useSelector(selectVoucherTypes);
    const [economyMinBalanceValue, setEconomyMinBalanceValue] = useState('');
    const [economyMaxBalanceValue, setEconomyMaxBalanceValue] = useState('');
    useEffect(() => {
        if (!voucherTypes) {
            c.economy.getVoucherTypes();
        }
    }, []);
    return (React.createElement(FilterGroup, { name: lang.caseFilter.economyGroup },
        React.createElement(FilterOption, { active: !!((_a = caseFilter.economyOnlyVoucherTypeIds) === null || _a === void 0 ? void 0 : _a.length), header: lang.caseFilter.economyOnlyVoucherTypeIds, onDeactivate: () => c.insights.clearFilter('economyOnlyVoucherTypeIds') },
            React.createElement(Select, { value: (caseFilter.economyOnlyVoucherTypeIds || []).map((voucherTypeId) => ({
                    label: lang.economyVoucherTypeLabels[voucherTypeId] || voucherTypeId,
                    value: voucherTypeId,
                })), isMulti: true, placeholder: lang.caseFilter.economyOnlyVoucherTypeIds, classNamePrefix: "select", options: (voucherTypes || [])
                    .filter((voucherType) => DebtorVoucherTypes.includes(voucherType.voucherTypeId))
                    .map((voucherType) => ({
                    label: lang.economyVoucherTypeLabels[voucherType.voucherTypeId] ||
                        voucherType.voucherTypeId,
                    value: voucherType.voucherTypeId,
                })), onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                    const selected = val ? val.map((v) => v.value) : [];
                    if (selected.length) {
                        c.insights.updateFilter({
                            economyOnlyVoucherTypeIds: selected,
                        });
                    }
                    else {
                        c.insights.clearFilter('economyOnlyVoucherTypeIds');
                    }
                }) }),
            React.createElement("br", null)),
        React.createElement(FilterOption, { active: typeof caseFilter.economyMinBalance === 'number', header: lang.caseFilter.economyMinAmount, onDeactivate: () => c.insights.clearFilter('economyMinBalance') },
            React.createElement(Input, { placeholder: lang.caseFilter.economyMinAmount, value: economyMinBalanceValue, onChange: (e) => {
                    const val = e.target.value;
                    setEconomyMinBalanceValue(val);
                    clearTimeout(tid);
                    tid = setTimeout(() => {
                        const isNumber = !isNaN(parseFloat(val));
                        c.insights.updateFilter({
                            economyMinBalance: isNumber ? parseFloat(val) * 100 : undefined,
                        });
                    }, 500);
                }, type: "number" })),
        React.createElement(FilterOption, { active: typeof caseFilter.economyMaxBalance === 'number', header: lang.caseFilter.economyMaxAmount, onDeactivate: () => c.insights.clearFilter('economyMaxBalance') },
            React.createElement(Input, { placeholder: lang.caseFilter.economyMaxAmount, value: economyMaxBalanceValue, onChange: (e) => {
                    const val = e.target.value;
                    setEconomyMaxBalanceValue(val);
                    clearTimeout(tid);
                    tid = setTimeout(() => {
                        const isNumber = !isNaN(parseFloat(val));
                        c.insights.updateFilter({
                            economyMaxBalance: isNumber ? parseFloat(val) * 100 : undefined,
                        });
                    }, 500);
                }, type: "number" })),
        React.createElement(FilterOption, { active: !!(caseFilter.billingModelIds && caseFilter.billingModelIds.length), header: lang.caseFilter.economyConnectors, onDeactivate: () => c.insights.clearFilter('billingModelIds') },
            React.createElement(Select, { value: (caseFilter.billingModelIds || []).map((id) => {
                    const billingModel = billingModels
                        ? billingModels.find((billingModel) => billingModel.billingModelId === id)
                        : undefined;
                    return { label: billingModel === null || billingModel === void 0 ? void 0 : billingModel.name, value: id };
                }), isMulti: true, placeholder: lang.caseFilter.billingModels, classNamePrefix: "select", options: (billingModels || [])
                    .filter((billingAppendixSetup) => !billingAppendixSetup.archived)
                    .map((billingModel) => ({
                    label: billingModel.name,
                    value: billingModel.billingModelId,
                })), onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        billingModelIds: selected.length ? selected : undefined,
                    });
                }) }))));
};
export default EconomyGroup;
//# sourceMappingURL=EconomyGroup.js.map